export default __webpack_public_path__ + "static/media/hexapodTop2@2x.bf8aaa27.png";